import borderRadius from "./index.es12.js";
import borderWidth from "./index.es13.js";
import opacity from "./index.es14.js";
import paddings from "./index.es15.js";
import spacings from "./index.es16.js";
const getSpacing = tokensMap(spacings, "spacing", 1);
const getPadding = tokensMap(paddings, "padding", 1);
const getBorderRadius = tokensMap(borderRadius, "borderRadius", 1);
const getBorderWidth = tokensMap(borderWidth, "borderWidth", 1);
const getOpacity = tokensMap(opacity, "opacity", 1);
function tokensMap(tokens, tokenPrefix, defaultValue) {
  return (...argsInput) => {
    const args = argsInput.length === 0 ? [defaultValue] : argsInput;
    return args.map((argument) => tokens[`${tokenPrefix}${argument}`]).join(" ");
  };
}
export {
  getBorderRadius,
  getBorderWidth,
  getOpacity,
  getPadding,
  getSpacing
};
//# sourceMappingURL=index.es3.js.map
